<template>
  <div class="alter-community-identity-main">
    <w-navbar
      :icon="'iconchevron-left'"
      nav_title="社群身份"
      @mobileLeftBtn="leftBtnClick"
    />

    <div class="toggle-button">
      <span class="show-desc">展示社群身份</span>
      <cube-switch v-model="isShowInput" @input="updateCommunityInfo('switch')"></cube-switch>
    </div>

    <div class="line"></div>

    <cube-loading :size="28" v-show="isLoading"></cube-loading>

    <div class="community-content" :class="{'slide': !isShowInput}" v-show="!isLoading">
      <template v-if="nowUserIdentify === 'student'">
        <div class="alter-input-item">
          <label>学校名称</label>
          <cube-input v-model="student_school" :maxlength="20" placeholder="请输入学校名称"></cube-input>
        </div>
        <div class="alter-input-item">
          <label>毕业时间</label>
          <cube-input v-model="student_year" :maxlength="5" placeholder="请输入毕业时间"></cube-input>
        </div>
      </template>

      <template v-if="nowUserIdentify === 'already_work'">
          <div class="alter-input-item">
            <label>公司名称</label>
            <cube-input v-model="company_name" :maxlength="20" placeholder="请输入公司名称"></cube-input>
          </div>
          <div class="alter-input-item">
            <label>职位名称</label>
            <cube-input v-model="company_position" :maxlength="20" placeholder="请输入职位名称"></cube-input>
          </div>
      </template>

      <button :class="{active: isActiveButton}" :disabled="!isActiveButton" @click="updateCommunityInfo()">保存</button>

      <p class="bottom-desc">社群身份用于社群和群聊中展示<br>填写真实的身份信息有利于你的职业形象</p>
    </div>

  </div>
</template>
<script>
	import WNavbar from '@/components/global/w-navbar'
  import { userMixin } from '@/assets/js/mixin/user'
  import { componentsMixin } from '../../assets/js/mixin/components'

	export default {
		name: 'AlterUserName',
		mixins: [ userMixin, componentsMixin ],
		components: {
			WNavbar
		},
		data () {
			return {
        communityInfo: {}, // 用户社群身份信息
        student_school: '', // 学校
        student_year: '', // 毕业年份
        company_name: '', // 公司名
        company_position: '', // 职位名
        nowUserIdentify: '', // 当前用户求职身份 学生或者职场人
        isShowInput: true, // 是否显示 input
        isLoading: false
			}
    },
    computed: {
      isActiveButton () {
        if (this.student_school && this.student_year) return true
        else if (this.company_name && this.company_position) return true
        else return false
      }
    },
    created () {
      this.getIdentifyInfo()
    },
		methods: {
			leftBtnClick () {
				this.$router.back()
			},
			save () {
      },
      // 拿到当前用户求职身份：学生student 或者 职场人already_work
      getIdentifyInfo () {
        this.isLoading = true
        let params = {id: this.cvAccountToken}
        let func = (res) => {
          this.nowUserIdentify = res.data.status
          this.isLoading = false
          this.getCommunityInfo()
        }
        this.requireData(this.$api.intention.getIdentity, params, func)
      },
      // 获取用户社群身份信息
      getCommunityInfo () {
        let params = this.cvAccountToken
        let func = (res) => {
          console.log('getCommunityInfo======>', res)
          this.communityInfo = res.data
          this.isShowInput = res.data.show_community_identity
          if (this.nowUserIdentify === 'student') {
            this.student_school = res.data.stu_community_prefix
            this.student_year = res.data.stu_community_suffix
          }
          if (this.nowUserIdentify === 'already_work') {
            this.company_name = res.data.com_community_prefix
            this.company_position = res.data.com_community_suffix
          }
        }
        this.requireData(this.$api.community.getCommunityInfo, params, func)
      },
      // 更新用户社群身份信息
      updateCommunityInfo (type) {
        let params = null
        let paramsBody = null

        if (this.nowUserIdentify === 'student') {
          paramsBody = {
            stu_community_prefix: this.student_school,
            stu_community_suffix: this.student_year,
          }
        }
        if (this.nowUserIdentify === 'already_work') {
          paramsBody = {
            com_community_prefix: this.company_name,
            com_community_suffix: this.company_position
          }
        }
        if (type === 'switch') {
          params = {
            rest: this.cvAccountToken,
            body: { show_community_identity: this.isShowInput }
          }
        } else {
          params = {
            rest: this.cvAccountToken,
            body: {
              ...paramsBody,
              show_community_identity: this.isShowInput
            }
          }
        }

        let func = (res) => {
          console.log('updateCommunityInfo======>', res)
          if (!type) {
            this.showToast('保存成功')
            setTimeout(() => {
              this.leftBtnClick()
            }, 1000)
          }
        }
        this.requireData(this.$api.community.updateCommunityInfo, params, func)
      },
      async requireData (requireFunc, params, callbackFunc) {
        try {
          let res = await requireFunc(params)
          if (res.code === 1000) {
            callbackFunc(res)
          } else {
            console.log(res.message)
          }
        } catch (error) {
          console.log(error)
        }
      }
		},
	}
</script>
<style lang="scss" scoped>
  .alter-community-identity-main {
    height: calc(100vh);
    background: #fff;
    padding-top: 44px;
    overflow: hidden;
    .toggle-button {
      position: relative;
      z-index: 10;
      width: 100%;
      height: 54px;
      background-color: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 23px;
      .show-desc {
        font-size: 13px;
        color: #404040;
      }
      /deep/ .cube-switch .cube-switch-ui {
        // border: none;
        // background-color: #9C9C9CFF;
      }
      /deep/ .cube-switch .cube-switch-input:checked+.cube-switch-ui {
        background-color: #FF6644FF;
      }
      /deep/ .cube-switch-ui {
        width: 41px;
        height: 19px;
        &:after {
          width: 19px;
        }
      }
      /deep/ .cube-switch .cube-switch-input:checked + .cube-switch-ui::after {
        transform: translateX(22px);
      }
    }
    .line {
      position: relative;
      z-index: 10;
      height: 7px;
      background: #F9F9F9;
    }
    .community-content {
      position: relative;
      top: 0;
      opacity: 1;
      width: 100%;
      height: calc(100vh - 44px - 54px - 7px);
      padding: 0 23px;
      background: #fff;
      transition: all 0.5s ease;
      &.slide {
        // height: 0;
        opacity: 0;
      }
      .alter-input-item {
        padding-top: 23px;
        label {
          font-size: 11px;
          color: #606060FF;
        }
      }
    }
    button {
      width: 100%;
      height: 40px;
      background: #ECECEC;
      border: none;
      border-radius: 4px;
      font-size: 15px;
      color: #9C9C9C;
      margin-top: 36px;
      &.active {
        background: #FF6644FF;
        color: #fff;
      }
    }
    .bottom-desc {
      width: 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 27px;
      text-align: center;
      font-size: 12px;
      color: #9C9C9CFF;
      line-height: 17px;
    }
  }
</style>
<style lang="scss">
  .alter-community-identity-main {
    .cube-input {
      width: 100% !important;
      border: none !important;
      border-bottom: 1px solid #EEEFF0FF !important;
    }
    .cube-input_active input {
      border: none !important;
      outline: none !important;
    }
    .cube-input input,
    .cube-input::after {
      border: none !important;
    }
    .cube-input-field {
      padding-left: 0 !important;
    }
    .cube-loading {
      position: absolute !important;
      left: 50% !important;
      top: 50% !important;
      transform: translate(-50%, -50%) !important;
    }
  }
</style>
